import styled from 'styled-components'

interface SpaceProps {
  margin: string;
}

// export const History = styled.div`

// `

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex:1;
  /* justify-content: space-between; */
  max-width: 33%;
  min-height: 120px;
  padding: 8px;

  border: 1px solid#095aa5;
  border-radius: 8px;

  span.title {
    position: absolute;
    top:0;
    left: 4px;
    padding: 0 4px;
    transform: translateY(-55%);
    background: #f8f8f8;

    color: #095aa5;
    font-size: 16px;
    font-weight: bold;
  }

  div {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }


  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
`

export const SuccesMessage = styled.p`
  color: ${props => props.color};
  font-weight: bold;
`

export const Space = styled.div<SpaceProps>`
  margin: ${props => props.margin ||  0}
`

export const Label = styled.h1`
  color: #095aa5;
  font-size: 16px;
`
